import { entity, list } from "./base";
import { concatModules } from "@/utility";

const name = "push_advertisments";

const initialEntity = {
  push_advertisments_id: null,
  title: "",
  body: "",
  image: [""],
  sent_at: null,
  target_num: 0,
  email_sent: 0,
  conditions: {}
};

const pushAdvertismentsEntityModule = {
  state: {
    open: false,
    pk: null,
    conditionsOpen: false,
    conditionsPk: null
  },
  mutations: {
    open(state, { pk }) {
      state.open = true;
      state.pk = pk;
    },
    openConditions(state, {pk}) {
      state.conditionsOpen = true;
      state.conditionsPk = pk;
    },
    close(state) {
      state.open = false;
      state.pk = null;
    },
    conditionsClose(state) {
      state.conditionsOpen = false;
      state.conditionsPk = null;
    }
  },
  actions: {
  },
  getters: {
    open(state) {
      return state.open;
    },
    pk(state) {
      return state.pk;
    },
    conditionsOpen(state) {
      return state.conditionsOpen;
    },
    conditionsPk(state) {
      return state.conditionsPk;
    }
  }
};

const entityModule = entity(name, initialEntity);

export const push_advertisments = {
  namespaced: true,
  modules: {
    list: list(name),
    entity: concatModules(entityModule, pushAdvertismentsEntityModule),
  }
};
